import Cookie from "js-cookie";
import { LINKED_ACCOUNTS_COOKIE_NAME } from "../../../common/constants/Constants";

function isTerminalSubscriber(): boolean {
    return (Cookie.get(LINKED_ACCOUNTS_COOKIE_NAME) || "").toLowerCase().includes("terminal");
}

export default isTerminalSubscriber;
